import { useMemo } from 'react';

import { ChipSelectOption } from '@components/ChipSelectOption/ChipSelectOption';
import {
  UK_ROLE_TYPE_OPTIONS,
  US_ROLE_TYPE_OPTIONS,
} from '@lib/utils/constants/applicationConstants';
import { useJobsBoardFiltersViewContext } from '@views/jobsBoard/context';
import { useJobsBoardFiltersModalContext } from '@views/jobsBoard/JobsBoardSection/JobsBoardFilters/JobsBoardFiltersModal/context';

import { FilterCollapse } from '../components/FilterCollapse';
import { StyledChipsContainer } from '../styles';
export const RoleTypeFilter = () => {
  const { modalFilters, toggleRoleType } = useJobsBoardFiltersModalContext();
  const { mainViewCountry } = useJobsBoardFiltersViewContext();

  const roleTypeOptions = useMemo(() => {
    if (mainViewCountry === 'UK') {
      return UK_ROLE_TYPE_OPTIONS;
    }
    return US_ROLE_TYPE_OPTIONS;
  }, [mainViewCountry]);

  const subtitle = useMemo(() => {
    if (!modalFilters?.roleTypes?.length) {
      return 'Any';
    }

    return (
      (roleTypeOptions as { label: string; value: string }[])
        .filter((roleType) => modalFilters?.roleTypes?.includes(roleType.value))
        .map((roleType) => roleType.label)
        .join(', ') || 'Any'
    );
  }, [modalFilters?.roleTypes, roleTypeOptions]);

  const applyMobileWidthReduction = useMemo(() => {
    return mainViewCountry !== 'UK';
  }, [mainViewCountry]);

  return (
    <FilterCollapse
      title={'Role Type'}
      subtitle={subtitle}
      content={
        <RoleTypeFilterContent
          roleTypes={modalFilters?.roleTypes}
          toggleRoleType={toggleRoleType}
          roleTypeOptions={roleTypeOptions}
          applyMobileWidthReduction={applyMobileWidthReduction}
        />
      }
    />
  );
};

type RoleTypeFilterContentProps = {
  roleTypes: string[] | undefined;
  toggleRoleType: (roleType: string) => void;
  roleTypeOptions: { label: string; value: string }[];
  applyMobileWidthReduction: boolean;
};
const RoleTypeFilterContent = ({
  roleTypes,
  toggleRoleType,
  roleTypeOptions,
  applyMobileWidthReduction,
}: RoleTypeFilterContentProps) => {
  return (
    <StyledChipsContainer applyMobileWidthReduction={applyMobileWidthReduction}>
      {roleTypeOptions.map((roleType) => (
        <ChipSelectOption
          key={`jobs-board-filter-role-type-${roleType.value}`}
          label={roleType.label}
          isSelected={roleTypes?.includes(roleType.value) ?? false}
          onClick={() => toggleRoleType(roleType.value)}
        />
      ))}
    </StyledChipsContainer>
  );
};
